<template>
    <div>
        <div class="wrapper" :style="getWrapperStyle">

            <div v-for="(item,idx) in getData" v-if=!item.active class="block-wrapper" :style="getBlockStyle(item,idx)">
                <div class="img-text-block" :style="getImageBlockStyle">
                    <img
                            :src="item.img"
                            alt="">
                    <span width="100%" :style="getText(item)"> {{item.text}}</span>
                </div>
                <div class="counter">
                    <span :style=""> {{item.actual}}</span>
                    <span class="total">/{{item.target}}</span>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'CardWithCounterTable',
        props: {
            config: {},
            componentData: {},
            dimensions: {},
            colorTheme: {},
        },
        data() {
            return {
                animationFired: false
            }
        },
        methods: {},
        computed: {
            getData(){
                return _.filter(this.componentData, function(o) { return !o.active; });
            },
            getImageBlockStyle(){
                return  "width:" + this.config.imageBlock.width + "; text-align:center;"
            },
            getImageStyle() {
                var CSS_STRING = "height:" + this.config.image.height + ";"
                CSS_STRING += "width:" + this.config.image.width + ";"

                return CSS_STRING
            },
            getWrapperStyle() {
                var CSS_STRING = "color:" + this.config.wrapper.color + ";"
                CSS_STRING += "background:" + this.config.wrapper.background + ";"
                CSS_STRING += "height:" + this.config.wrapper.height + ";"
                CSS_STRING += "width:" + this.config.wrapper.width + ";"
                return CSS_STRING

            },

        },
        methods: {
            getBlockStyle(item,idx) {
                // defaults are set here.
                if(!item.status ){
                    var item  ={ status:  'default'}
                }
                var CSS_STRING = ''
                CSS_STRING += "height:" + this.config.block.height + ";"
                CSS_STRING += "width:" + this.config.block.width + ";"
                CSS_STRING += "margin:" + this.config.block.margin + ";"
                CSS_STRING += "background:" + this.config.block.background[item.status] + ";"
                CSS_STRING += "color:" + this.config.block.color[item.status] + ";"



                return CSS_STRING
            },
            getText(item) {
                var CSS_STRING = "color:" + this.config.block.color[item.status] + ";"
                CSS_STRING += "font-size:" + this.config.text.fontSize + ";"

                return CSS_STRING
            },
            getCurrentValue() {
                var self = this
                return 100
                return _.reduce(this.componentData, function (sum, n) {
                    if (n.Status == self.dimensions[0]) {
                        return sum + n.Value;
                    }
                    return sum
                }, 0);
            },
            getTotalValue() {
                return 230
                return _.reduce(this.componentData, function (sum, n) {
                    return sum + n.Value;
                }, 0);
            },
        },
        watch: {
            componentData(newValue) {
                // var top = $(".counter").position().top
                // var left = $(".counter").position().left
                if (!this.animationFired)
                    if (newValue.currentValue >= newValue.totalValue) {

                    }
            }
        },
        created() {


        }
    }
</script>
<style lang="scss" scoped>


    .block-wrapper {
        position: relative;
        float: left;
        width: 100%;
        .img-text-block {
            text-align: center;
            top: 50%;

            -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
            position: absolute;
            img {

                width:100%;
                margin:0 auto;
                padding-left: 50px;
            }
            span {
                padding-left: 50px;
                /*position: absolute;*/
                /*left: 0;*/
                top: 130%;
                text-align:center;
                -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
                font-weight: 700;
            }

        }
        .counter {
            position: absolute;
            top: 50%;
            width: 100%;
            -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
            text-align: right;
            padding-right: 20px;
            font-size: 100px;
            font-weight: 700;
            vertical-align: middle;
            line-height: 10vh;
            .total {
                font-size: 100px;
            }
        }

    }


</style>